import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import NewTaskModal from 'modules/tasks/components/NewTaskModal'

const useOnClose = (id: string) => {
  const { navigation } = useNavigation()

  const navigate = useNavigate()

  return () => navigate(navigation.employees.id.tasks.fullPath({ id }))
}

const NewPage = () => {
  const { id } = useStrictParams<'id'>()
  const onClose = useOnClose(id)

  return <NewTaskModal onClose={onClose} />
}

export default NewPage
